import { Box } from "@mui/material";
import { SubmissionConfirmationCard } from "components/Feedback/SubmissionConfirmationCard";
import { MainLayoutContainer } from "components/Layout";
import { AdminRoutes } from "config/routes";
import { VETCOIN_REWARDS } from "hooks/useVetcoin";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

type ConfirmationLocationState = {
  title?: string;
  vetcoinsAwarded?: number;
};

export const FeedbackSubmissionConfirmation = () => {
  const location = useLocation();
  const state = (location.state || {}) as ConfirmationLocationState;

  const title = useMemo(
    () => state.title || "Coach Feedback Successfully Submitted",
    [state.title],
  );
  const vetcoinsAwarded = useMemo(
    () =>
      state.vetcoinsAwarded ??
      VETCOIN_REWARDS.FEEDBACK_EVALUATION_COMPLETED,
    [state.vetcoinsAwarded],
  );

  return (
    <MainLayoutContainer title="Feedback Confirmation" size="small">
      <Box>
        <SubmissionConfirmationCard
          title={title}
          vetcoinsAwarded={vetcoinsAwarded}
          buttonTo={AdminRoutes.Home}
        />
      </Box>
    </MainLayoutContainer>
  );
};
